import dayjsTZ from "../../../utils/dayjs";

const getDate = (date, format) =>
  !!date ? dayjsTZ(date).format(format) : null;

export const colDefs = ({ dayTypes = {} }) => [
  {
    headerName: "Clocking Id",
    field: "clockingId",
    hide: true,
  },
  {
    headerName: "Fillimi",
    field: "fillim_turni",
    flex: 3,
    mobile: true,
    filter: "agTextColumnFilter",
    format: "HH:mm",
    isExported: true,
    valueGetter: ({ data = {} }) => getDate(data.fillim_turni, "HH:mm"),
    cellRenderer: ({ data = {} }) => getDate(data.fillim_turni, "HH:mm"),
  },
  {
    headerName: "Mbarimi",
    field: "mbarim_turni",
    flex: 3,
    mobile: true,
    filter: "agTextColumnFilter",
    format: "HH:mm",
    isExported: true,
    valueGetter: ({ data = {} }) => getDate(data.mbarim_turni, "HH:mm"),
    cellRenderer: ({ data = {} }) =>
      !!data.mbarim_turni ? (
        dayjsTZ(data.mbarim_turni).format("HH:mm")
      ) : (
        <strong style={{ color: "red" }}>I pacaktuar</strong>
      ),
  },
  {
    headerName: "Data e turnit",
    field: "clockInDate",
    flex: 3,
    filter: "agTextColumnFilter",
    mobile: true,
    isExported: true,
    format: "DD/MM/YYYY",
    isCollapseTitle: true,
    valueGetter: ({ data }) => getDate(data?.clockInDate, "DD/MM/YYYY"),
  },
  {
    headerName: "Krijuar në",
    field: "createdAt",
    flex: 3,
    filter: "agTextColumnFilter",
    mobile: true,
    isExported: true,
    format: "DD/MM/YYYY",
    valueGetter: ({ data }) => getDate(data?.createdAt, "DD/MM/YYYY"),
  },
  {
    headerName: "Statusi",
    field: "approved",
    flex: 3,
    mobile: true,
    isExported: true,
    filter: "agTextColumnFilter",
    valueGetter: ({ data }) => {
      if (data?.approved === true) {
        return "Aprovuar";
      } else {
        return "Pa Aprovuar";
      }
    },
    cellRenderer: ({ data }) => renderStatus(data?.approved),
  },
  {
    headerName: "Kohëzgjatja",
    field: "duration",
    flex: 3,
    isExported: true,
    filter: "agTextColumnFilter",
    mobile: true,
    valueGetter: ({ data }) => data?.duration,
  },
  {
    headerName: "Lloji i turnit",
    field: "dayType",
    mobile: true,
    flex: 3,
    isExported: true,
    filterParams: { apply: true, newRowsAction: "keep" },
    hide: false,
    valueGetter: ({ data = {} }) => dayTypes[data.dayType] || "",
    cellRenderer: ({ data = {} }) => dayTypes[data.dayType] || "",
  },
];

//region >renderStatus()
const renderStatus = (val) => {
  const statuses = {
    true: {
      background: "#1da193",
      label: "Aprovuar",
    },
    false: {
      background: "#ea3943",
      label: "Pa Aprovuar",
    },
    default: {
      background: "grey",
      label: "Pa Përcaktuar",
    },
  };

  const { background, label } = statuses?.[val] || statuses.default;
  return (
    <div className="status-column">
      <span style={{ background }}>{label}</span>
    </div>
  );
};
